/* Saucy Bird Theme JS — Conversion Optimised */

document.addEventListener('DOMContentLoaded', function() {

  // ── HEADER SCROLL ──
  const header = document.getElementById('site-header');
  if (header) {
    window.addEventListener('scroll', () => {
      header.classList.toggle('scrolled', window.scrollY > 40);
    });
  }

  // ── SCROLL REVEAL ──
  const reveals = document.querySelectorAll('.reveal');
  if (!('IntersectionObserver' in window)) {
    // No observer support — show everything rather than hiding it forever.
    reveals.forEach(el => el.classList.add('visible'));
  } else {
    const revealObs = new IntersectionObserver((entries) => {
      entries.forEach((entry, i) => {
        if (entry.isIntersecting) {
          setTimeout(() => entry.target.classList.add('visible'), i * 60);
          revealObs.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -30px 0px' });
    reveals.forEach(el => revealObs.observe(el));
    // Safety net: nothing stays invisible for more than 2.5s.
    setTimeout(() => reveals.forEach(el => el.classList.add('visible')), 2500);
  }

  // ── HTTP / FORM HELPERS ──
  async function fetchOrThrow(url, options) {
    const res = await fetch(url, options);
    if (res.ok) return res;

    let message = `Request failed (${res.status})`;
    try {
      const data = await res.clone().json();
      message = data.description || data.message || message;
    } catch (_) {
      try {
        const text = await res.text();
        if (text) message = text;
      } catch (_) {}
    }
    throw new Error(message);
  }

  function showFormError(form, message) {
    if (!form) return;
    let error = form.querySelector('.sb-form-error');
    if (!error) {
      error = document.createElement('div');
      error.className = 'sb-form-error';
      error.setAttribute('role', 'alert');
      form.appendChild(error);
    }
    error.textContent = message || t('form_error');
    error.hidden = false;
  }

  function clearFormError(form) {
    const error = form && form.querySelector('.sb-form-error');
    if (error) { error.textContent = ''; error.hidden = true; }
  }

  // ── LANGUAGE / MONEY HELPERS ──
  // Weglot translates the server-rendered page, but cart/add-on/PDP status
  // strings are injected after page load. Keep those strings locale-aware here
  // so commerce UI remains correct even before/without a Weglot dynamic rule.
  const SB_COPY = {
    en: {
      add: 'Add',
      adding: 'Adding…',
      adding_plain: 'Adding...',
      added: '✓ Added',
      add_to_cart: 'Add to Cart',
      add_product: 'Add {product}',
      free_shipping_unlocked: 'Free shipping unlocked.',
      free_shipping_over: 'Free shipping over {amount}',
      free_shipping_remaining: "You're {amount} from free shipping",
      cart_empty_title: 'Your cart is empty.',
      cart_empty_copy: 'Add something worth eating.',
      form_error: 'Something went wrong. Please try again.',
      read_more: 'Read more',
      read_less: 'Read less',
      email_unavailable: 'Email alerts are temporarily unavailable.',
      back_in_stock_success: "You're on the list. We'll let you know.",
      generic_try_again: 'Something went wrong. Try again.',
      ledger_claiming: 'Claiming...',
      ledger_joined: 'Joined ✓',
      ledger_claim: 'Claim Your Number',
      ledger_success: "You're on the list. Check your email.",
      nav_shop_all: 'Shop All',
      nav_sauces: 'Sauces',
      nav_rubs: 'Rubs',
      nav_story: 'Our Story',
      nav_wholesale: 'Wholesale',
      nav_society: 'The Society'
    },
    fr: {
      add: 'Ajouter',
      adding: 'Ajout…',
      adding_plain: 'Ajout...',
      added: '✓ Ajouté',
      add_to_cart: 'Ajouter au panier',
      add_product: 'Ajouter {product}',
      free_shipping_unlocked: 'Livraison gratuite débloquée.',
      free_shipping_over: 'Livraison gratuite à partir de {amount}',
      free_shipping_remaining: 'Plus que {amount} pour la livraison gratuite',
      cart_empty_title: 'Votre panier est vide.',
      cart_empty_copy: 'Ajoutez quelque chose de bon.',
      form_error: 'Un problème est survenu. Veuillez réessayer.',
      read_more: 'Lire la suite',
      read_less: 'Réduire',
      email_unavailable: 'Les alertes courriel sont temporairement indisponibles.',
      back_in_stock_success: 'Vous êtes sur la liste. Nous vous préviendrons.',
      generic_try_again: 'Un problème est survenu. Réessayez.',
      ledger_claiming: 'Inscription...',
      ledger_joined: 'Inscrit ✓',
      ledger_claim: 'Réclamez votre numéro',
      ledger_success: 'Vous êtes sur la liste. Vérifiez votre courriel.',
      nav_shop_all: 'Tous les produits',
      nav_sauces: 'Sauces',
      nav_rubs: 'Assaisonnements',
      nav_story: 'Notre histoire',
      nav_wholesale: 'Vente en gros',
      nav_society: 'The Society'
    }
  };

  function currentLanguage() {
    try {
      if (window.Weglot && typeof window.Weglot.getCurrentLang === 'function') {
        return (window.Weglot.getCurrentLang() || 'en').toLowerCase().split('-')[0];
      }
    } catch (_) {}
    return (document.documentElement.lang || 'en').toLowerCase().split('-')[0];
  }

  function t(key, vars) {
    const lang = currentLanguage();
    const dict = SB_COPY[lang] || SB_COPY.en;
    let out = dict[key] || SB_COPY.en[key] || key;
    Object.entries(vars || {}).forEach(([name, value]) => {
      out = out.replaceAll('{' + name + '}', value);
    });
    return out;
  }

  function formatMoney(cents) {
    const lang = currentLanguage();
    const locale = lang === 'fr' ? 'fr-CA' : 'en-CA';
    try {
      return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency: 'CAD',
        currencyDisplay: 'narrowSymbol',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format((Number(cents) || 0) / 100);
    } catch (_) {
      return '$' + ((Number(cents) || 0) / 100).toFixed(2);
    }
  }

  function idleButtonText(btn, fallback) {
    if (!btn) return fallback || '';
    const key = btn.dataset.sbLabelKey;
    if (!key) return fallback || btn.textContent.trim();
    if (key === 'add_product') {
      return t(key, { product: btn.dataset.sbProductTitle || '' });
    }
    return t(key);
  }

  function applyDynamicLanguage() {
    document.querySelectorAll('[data-sb-label-key]').forEach(btn => {
      if (btn.disabled && (btn.textContent.includes('…') || btn.textContent.includes('...'))) return;
      btn.textContent = idleButtonText(btn, btn.textContent.trim());
    });

    document.querySelectorAll('[data-sb-nav-key]').forEach(link => {
      link.textContent = t(link.dataset.sbNavKey);
    });

    const descToggle = document.getElementById('product-desc-toggle');
    const descEl = document.getElementById('product-desc');
    if (descToggle && descEl) {
      descToggle.textContent = descEl.classList.contains('is-open') ? t('read_less') : t('read_more');
    }
  }

  // ── CART COUNT UPDATE ──
  async function updateCartCount() {
    try {
      const res = await fetchOrThrow('/cart.js');
      const cart = await res.json();
      document.querySelectorAll('.cart-count').forEach(el => {
        el.textContent = cart.item_count;
        el.style.display = cart.item_count > 0 ? 'flex' : 'none';
      });
      // Update cart subtotal if drawer is open
      const totalEl = document.getElementById('cart-total');
      if (totalEl) {
        totalEl.textContent = formatMoney(cart.total_price);
      }
      // Render cart items
      renderCartItems(cart);
      updateShipBar(cart);
      updatePdpShipBar(cart);
      renderAddons(cart);
      const soc = document.getElementById('cart-society');
      if (soc) {
        const hasMembership = cart.items.some(i => (i.product_type || '') === 'Membership');
        soc.hidden = cart.item_count === 0 || hasMembership;
      }
    } catch (err) {}
  }

  // ── FREE SHIPPING PROGRESS ──
  function updateShipBar(cart) {
    const wrap = document.getElementById('cart-ship');
    const msg  = document.getElementById('cart-ship-msg');
    const fill = document.getElementById('cart-ship-fill');
    if (!wrap || !msg || !fill) return;
    const threshold = window.SB_FREE_SHIP || 7500;
    if (!cart || cart.item_count === 0) { wrap.hidden = true; return; }
    wrap.hidden = false;
    const remaining = threshold - cart.total_price;
    const pct = Math.min(100, (cart.total_price / threshold) * 100);
    fill.style.width = pct + '%';
    if (remaining <= 0) {
      msg.textContent = t('free_shipping_unlocked');
      msg.classList.add('is-free');
      fill.classList.add('is-free');
    } else {
      msg.innerHTML = t('free_shipping_remaining', { amount: '<strong>' + formatMoney(remaining) + '</strong>' });
      msg.classList.remove('is-free');
      fill.classList.remove('is-free');
    }
  }

  // ── PDP FREE SHIPPING PROGRESS ──
  function updatePdpShipBar(cart) {
    const msg = document.getElementById('pdp-ship-msg');
    const fill = document.getElementById('pdp-ship-fill');
    if (!msg || !fill) return;
    const threshold = window.SB_FREE_SHIP || 7500;
    const total = cart ? cart.total_price : 0;
    const remaining = threshold - total;
    const pct = Math.min(100, (total / threshold) * 100);

    if (total >= threshold) {
      msg.textContent = t('free_shipping_unlocked');
      msg.classList.add('is-free');
      fill.classList.add('is-free');
      fill.style.width = '100%';
    } else if (total > 0) {
      msg.innerHTML = t('free_shipping_remaining', { amount: '<strong>' + formatMoney(remaining) + '</strong>' });
      msg.classList.remove('is-free');
      fill.classList.remove('is-free');
      fill.style.width = pct + '%';
    } else {
      msg.innerHTML = t('free_shipping_over', { amount: '<strong>' + formatMoney(threshold) + '</strong>' });
      msg.classList.remove('is-free');
      fill.classList.remove('is-free');
      fill.style.width = '0%';
    }
  }

  // ── CART ADD-ONS ──
  function renderAddons(cart) {
    const wrap = document.getElementById('cart-addons');
    const row  = document.getElementById('cart-addons-row');
    if (!wrap || !row) return;
    const pool = window.SB_ADDONS || [];
    if (!cart || cart.item_count === 0 || !pool.length) { wrap.hidden = true; return; }
    const inCart = cart.items.map(i => i.handle);
    const avail = pool.filter(p => inCart.indexOf(p.handle) === -1);
    // Pair across categories: a cart of sauces gets rubs shown first, and vice versa.
    const cartKinds = pool.filter(p => inCart.indexOf(p.handle) !== -1).map(p => p.kind);
    const rubs = cartKinds.filter(k => k === 'rub').length;
    const sauces = cartKinds.filter(k => k === 'sauce').length;
    const want = rubs > sauces ? 'sauce' : 'rub';
    const picks = avail.slice().sort((a, b) => (b.kind === want) - (a.kind === want)).slice(0, 4);
    if (!picks.length) { wrap.hidden = true; return; }
    wrap.hidden = false;
    row.innerHTML = picks.map(p => `
      <div class="cart-addon">
        <a href="/products/${p.handle}"><img src="${p.image}" alt="${p.title}" loading="lazy"></a>
        <div class="cart-addon-title">${p.title}</div>
        <div class="cart-addon-price">${formatMoney(p.price)}</div>
        <button class="cart-addon-btn" data-addon-id="${p.id}">${t('add')}</button>
      </div>`).join('');
  }

  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('.cart-addon-btn');
    if (!btn) return;
    btn.disabled = true;
    btn.textContent = t('adding');
    try {
      await fetchOrThrow('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: btn.dataset.addonId, quantity: 1 })
      });
      await updateCartCount();
    } catch (err) {
      btn.disabled = false;
      btn.textContent = t('add');
    }
  });

  // ── RENDER CART ITEMS ──
  async function renderCartItems(cart) {
    const container = document.getElementById('cart-items');
    if (!container) return;
    if (!cart) {
      try {
        const res = await fetchOrThrow('/cart.js');
        cart = await res.json();
      } catch(e) { return; }
    }
    if (cart.item_count === 0) {
      container.innerHTML = `
        <div style="padding:48px 0;text-align:center;color:var(--grey);">
          <p style="font-family:var(--font);font-size:16px;font-weight:900;text-transform:uppercase;margin-bottom:8px;letter-spacing:0.02em;">${t('cart_empty_title')}</p>
          <p style="font-size:12px;font-weight:300;">${t('cart_empty_copy')}</p>
        </div>`;
      return;
    }
    container.innerHTML = cart.items.map(item => `
      <div class="cart-item">
        <img class="cart-item-image" src="${item.image}" alt="${item.title}">
        <div>
          <div class="cart-item-title">${item.product_title}</div>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="cart-item-variant">${item.variant_title}</div>` : ''}
          <div class="cart-item-qty">
            <button class="qty-btn" data-key="${item.key}" data-action="decrease">−</button>
            <span class="qty-num">${item.quantity}</span>
            <button class="qty-btn" data-key="${item.key}" data-action="increase">+</button>
          </div>
        </div>
        <div class="cart-item-price">${formatMoney(item.line_price)}</div>
      </div>`).join('');
  }

  // ── CART DRAWER OPEN/CLOSE ──
  const cartOverlay = document.getElementById('cart-overlay');
  const cartDrawer = document.getElementById('cart-drawer');

  let savedScrollY = 0;

  function lockScroll() {
    savedScrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = -savedScrollY + 'px';
    document.body.style.width = '100%';
    document.body.style.overflow = 'hidden';
  }

  function unlockScroll() {
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    document.body.style.overflow = '';
    window.scrollTo(0, savedScrollY);
  }

  function openCart() {
    cartOverlay && cartOverlay.classList.add('open');
    cartDrawer && cartDrawer.classList.add('open');
    lockScroll();
    updateCartCount();
  }

  function closeCart() {
    cartOverlay && cartOverlay.classList.remove('open');
    cartDrawer && cartDrawer.classList.remove('open');
    unlockScroll();
  }

  // Escape key closes the drawer.
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('open')) closeCart();
  });

  // Safety net: if the page is restored from bfcache with a stuck lock, clear it.
  window.addEventListener('pageshow', () => {
    if (!cartDrawer || !cartDrawer.classList.contains('open')) {
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';
      document.body.style.overflow = '';
    }
  });

  document.querySelectorAll('[data-cart-open]').forEach(btn => btn.addEventListener('click', openCart));
  document.getElementById('cart-close') && document.getElementById('cart-close').addEventListener('click', closeCart);
  cartOverlay && cartOverlay.addEventListener('click', closeCart);

  // ── QTY BUTTONS IN CART ──
  document.addEventListener('click', async function(e) {
    const btn = e.target.closest('.qty-btn');
    if (!btn) return;
    const key = btn.dataset.key;
    const action = btn.dataset.action;
    const wrap = btn.closest('.cart-item-qty');
    const numEl = wrap && wrap.querySelector('.qty-num');
    if (!numEl || !key) return;
    let qty = parseInt(numEl.textContent);
    if (action === 'increase') qty++;
    if (action === 'decrease') qty = Math.max(0, qty - 1);
    const qtyButtons = wrap.querySelectorAll('.qty-btn');
    qtyButtons.forEach(b => b.disabled = true);
    try {
      await fetchOrThrow('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      await updateCartCount();
    } catch(e) {
      console.error('Saucy Bird cart quantity update failed:', e);
      await updateCartCount();
    } finally {
      qtyButtons.forEach(b => b.disabled = false);
    }
  });

  // ── ADD TO CART ──
  document.addEventListener('submit', async function(e) {
    const form = e.target.closest('[data-add-to-cart-form]');
    if (!form) return;
    e.preventDefault();
    const btn = form.querySelector('[data-add-to-cart-btn]');
    const stickyBtn = document.getElementById('sticky-atc-btn');
    if (!btn) return;
    const originalText = btn.textContent.trim();
    const idleText = () => idleButtonText(btn, originalText);
    const syncSticky = Boolean(stickyBtn && form.id && stickyBtn.getAttribute('form') === form.id);
    const stickyOriginalText = syncSticky ? stickyBtn.textContent.trim() : '';
    const stickyIdleText = () => syncSticky ? idleButtonText(stickyBtn, stickyOriginalText) : '';
    clearFormError(form);
    btn.textContent = t('adding_plain');
    btn.disabled = true;
    if (syncSticky) { stickyBtn.textContent = t('adding_plain'); stickyBtn.disabled = true; }

    try {
      const formData = new FormData(form);
      await fetchOrThrow('/cart/add.js', { method: 'POST', body: formData });
      btn.textContent = t('added');
      if (syncSticky) stickyBtn.textContent = t('added');
      setTimeout(() => {
        btn.textContent = idleText();
        btn.disabled = false;
        if (syncSticky) { stickyBtn.textContent = stickyIdleText(); stickyBtn.disabled = false; }
        openCart();
      }, 500);
    } catch (err) {
      btn.textContent = idleText();
      btn.disabled = false;
      if (syncSticky) { stickyBtn.textContent = stickyIdleText(); stickyBtn.disabled = false; }
      showFormError(form, err && err.message);
      console.error('Saucy Bird add-to-cart failed:', err);
    }
  });

  // ── STICKY ADD TO CART (product pages) ──
  const productForm = document.querySelector('[data-add-to-cart-form]');
  const productBtn = document.querySelector('[data-add-to-cart-btn]');
  const stickyBar = document.getElementById('sticky-atc-bar');

  if (productBtn && stickyBar) {
    document.body.classList.add('has-sticky-atc');
    const stickyObs = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        stickyBar.classList.toggle('visible', !entry.isIntersecting);
      });
    }, { threshold: 0 });
    stickyObs.observe(productBtn);
  }

  // ── GALLERY THUMBS ──
  document.querySelectorAll('.product-thumb').forEach(thumb => {
    thumb.addEventListener('click', () => {
      document.querySelectorAll('.product-thumb').forEach(t => t.classList.remove('active'));
      thumb.classList.add('active');
      const mainImg = document.querySelector('.product-gallery-main img');
      if (mainImg) {
        const src = thumb.querySelector('img').src;
        mainImg.src = src;
        mainImg.style.opacity = '0';
        setTimeout(() => mainImg.style.opacity = '1', 50);
      }
    });
  });

  // ── PDP DESCRIPTION TOGGLE (mobile) ──
  const descToggle = document.getElementById('product-desc-toggle');
  const descEl = document.getElementById('product-desc');
  if (descToggle && descEl) {
    // Only offer the toggle if the text is actually being clipped.
    const needsToggle = () => descEl.scrollHeight > descEl.clientHeight + 2;
    const sync = () => {
      if (descEl.classList.contains('is-open')) return;
      descToggle.style.visibility = needsToggle() ? 'visible' : 'hidden';
    };
    sync();
    window.addEventListener('resize', sync);
    descToggle.addEventListener('click', () => {
      const open = descEl.classList.toggle('is-open');
      descToggle.textContent = open ? t('read_less') : t('read_more');
      descToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  // ── BACK IN STOCK FORM ──
  const bistForm = document.getElementById('back-in-stock-form');
  if (bistForm) {
    bistForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      const email = bistForm.querySelector('input[type="email"]').value;
      const variantId = bistForm.dataset.variantId || bistForm.dataset.productId;
      const msg = document.getElementById('bist-message');
      const publicKey = window.SB_KLAVIYO_PUBLIC_KEY || '';
      if (!publicKey || !variantId) {
        if (msg) { msg.textContent = t('email_unavailable'); msg.style.color = 'var(--coral)'; }
        return;
      }
      // Klaviyo client back-in-stock endpoint requires the public Site ID.
      try {
        await fetchOrThrow(`https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(publicKey)}`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'revision': '2024-10-15'
          },
          body: JSON.stringify({
            data: {
              type: 'back-in-stock-subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email } } },
                channels: ['EMAIL']
              },
              relationships: {
                variant: { data: { type: 'catalog-variant', id: `$shopify:::$default:::${variantId}` } }
              }
            }
          })
        });
        if (msg) { msg.textContent = t('back_in_stock_success'); msg.style.color = 'var(--olive)'; }
        bistForm.querySelector('input').value = '';
      } catch(err) {
        if (msg) { msg.textContent = t('generic_try_again'); msg.style.color = 'var(--coral)'; }
        console.error('Saucy Bird back-in-stock signup failed:', err);
      }
    });
  }

  // ── SAUCE LEDGER EMAIL CAPTURE ──
  const ledgerForm = document.getElementById('ledger-email-form');
  if (ledgerForm) {
    ledgerForm.addEventListener('submit', async function(e) {
      e.preventDefault();
      const email = ledgerForm.querySelector('input[type="email"]').value;
      const msg = document.getElementById('ledger-message');
      const btn = ledgerForm.querySelector('button');
      if (btn) { btn.textContent = t('ledger_claiming'); btn.disabled = true; }
      try {
        const publicKey = window.SB_KLAVIYO_PUBLIC_KEY || '';
        const listId = window.SB_LEDGER_LIST_ID || '';
        if (!publicKey || !listId) throw new Error('Ledger signup is not configured.');

        await fetchOrThrow(`https://a.klaviyo.com/client/subscriptions/?company_id=${encodeURIComponent(publicKey)}`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'revision': '2024-10-15' },
          body: JSON.stringify({
            data: {
              type: 'subscription',
              attributes: {
                profile: { data: { type: 'profile', attributes: { email } } }
              },
              relationships: {
                list: { data: { type: 'list', id: listId } }
              }
            }
          })
        });
        if (msg) { msg.textContent = t('ledger_success'); msg.style.color = 'white'; }
        if (btn) { btn.textContent = t('ledger_joined'); }
        ledgerForm.querySelector('input').value = '';
      } catch(err) {
        if (msg) { msg.textContent = t('generic_try_again'); }
        if (btn) { btn.textContent = t('ledger_claim'); btn.disabled = false; }
        console.error('Saucy Bird Ledger signup failed:', err);
      }
    });
  }

  // ── FILTER BUTTONS ──
  document.querySelectorAll('.filter-btn').forEach(btn => {
    btn.addEventListener('click', () => {
      document.querySelectorAll('.filter-btn').forEach(b => b.classList.remove('active'));
      btn.classList.add('active');
      const filter = btn.dataset.filter;
      document.querySelectorAll('.product-card').forEach(card => {
        if (filter === 'all') {
          card.style.display = '';
        } else if (filter === 'set') {
          card.style.display = card.dataset.set === 'true' ? '' : 'none';
        } else {
          const type = (card.dataset.productType || '').toLowerCase();
          card.style.display = type.includes(filter) ? '' : 'none';
        }
      });
    });
  });

  // ── MOBILE MENU ──
  const menuToggle = document.getElementById('menu-toggle');
  const mobileMenu = document.getElementById('mobile-menu');

  function setMenu(open) {
    if (!mobileMenu) return;
    if (open) {
      // The drop banner sits above a sticky header, so the header's top edge
      // moves as the page scrolls. Anchor the menu to where the header
      // actually ends rather than a hardcoded 68px.
      const hdr = document.getElementById('site-header');
      if (hdr) mobileMenu.style.top = Math.max(0, hdr.getBoundingClientRect().bottom) + 'px';
    }
    mobileMenu.style.display = open ? 'block' : 'none';
    menuToggle && menuToggle.setAttribute('aria-expanded', open ? 'true' : 'false');
  }

  menuToggle && menuToggle.addEventListener('click', function(e) {
    e.stopPropagation();
    setMenu(!mobileMenu || mobileMenu.style.display === 'none');
  });

  // Tapping a link closes the menu; so does tapping anywhere outside it.
  mobileMenu && mobileMenu.addEventListener('click', e => {
    if (e.target.closest('a')) setMenu(false);
  });
  document.addEventListener('click', e => {
    if (!mobileMenu || mobileMenu.style.display === 'none') return;
    if (e.target.closest('#mobile-menu') || e.target.closest('#menu-toggle')) return;
    setMenu(false);
  });

  function handleResize() {
    const toggle = document.getElementById('menu-toggle');
    const menu = document.getElementById('mobile-menu');
    if (window.innerWidth <= 768) {
      toggle && (toggle.style.display = 'flex');
    } else {
      toggle && (toggle.style.display = 'none');
      menu && (menu.style.display = 'none');
      toggle && toggle.setAttribute('aria-expanded', 'false');
    }
  }
  handleResize();
  window.addEventListener('resize', handleResize);

  // ── FOUNDER NUMBER COUNTDOWN ──
  const countdownEl = document.getElementById('founder-remaining');
  if (countdownEl) {
    // This would pull from a metafield or hardcoded — update as numbers sell
    const remaining = parseInt(countdownEl.dataset.remaining || '40');
    const total = 50;
    const claimed = total - remaining;
    const bar = document.getElementById('founder-bar');
    if (bar) bar.style.width = (claimed / total * 100) + '%';
  }

  function refreshLocaleAwareCommerce() {
    applyDynamicLanguage();
    updateCartCount();
  }

  function bindWeglotLanguageEvents(attempt) {
    attempt = attempt || 0;
    if (window.Weglot && typeof window.Weglot.on === 'function') {
      window.Weglot.on('languageChanged', function() {
        // Weglot has switched languages; repaint JS-owned commerce strings
        // after its DOM pass so neither system overwrites the other.
        setTimeout(refreshLocaleAwareCommerce, 0);
      });
      window.Weglot.on('initialized', function() {
        setTimeout(refreshLocaleAwareCommerce, 0);
      });
      if (window.Weglot.initialized) setTimeout(refreshLocaleAwareCommerce, 0);
      return;
    }
    if (attempt < 40) setTimeout(function() { bindWeglotLanguageEvents(attempt + 1); }, 100);
  }

  applyDynamicLanguage();
  bindWeglotLanguageEvents(0);
  updateCartCount();
});
